import {match} from 'ts-pattern';

import {TelephonyGroup} from '@dms/api/settings';
import i18n from '@dms/i18n';

/** Twilio rings at most this many numbers in one simultaneous `<Dial>`; extra members are picked at random per call. */
export const SIMULTANEOUS_RING_CAP = 10;

export const getTelephonyGroupSummary = (
  group: Pick<TelephonyGroup, 'ringStrategy' | 'ringSeconds' | 'memberUserIds'>
) =>
  match(group.ringStrategy)
    .with('simultaneous', () =>
      i18n.t('page.settings.telephony.groupSummarySimultaneous', {
        count: group.memberUserIds.length,
        seconds: group.ringSeconds,
      })
    )
    .with('sequential', () =>
      i18n.t('page.settings.telephony.groupSummarySequential', {
        count: group.memberUserIds.length,
        seconds: group.ringSeconds,
      })
    )
    .exhaustive();

export const getRingStrategyLabel = (ringStrategy: TelephonyGroup['ringStrategy']) =>
  match(ringStrategy)
    .with('simultaneous', () => i18n.t('page.settings.telephony.ringStrategySimultaneous'))
    .with('sequential', () => i18n.t('page.settings.telephony.ringStrategySequential'))
    .exhaustive();
